/* eslint-disable react/require-default-props */
import React, { Fragment } from 'react';
import { Tooltip } from '@material-ui/core';

import { CapBalanceInfo } from 'entities/user/model';
import { currencyFormat, currencies } from 'utils/currencyFormat';

const CapBalance = ({
  capBalanceByBudget,
  unlimitedMessaging,
  budget,
}: {
  capBalanceByBudget: CapBalanceInfo[];
  unlimitedMessaging?: string;
  // Show info only for this budget
  budget?: string;
}): JSX.Element => {
  if (!capBalanceByBudget?.length) {
    return <>No budget</>;
  }

  return (
    <>
      {capBalanceByBudget
        .filter(
          ({ balance, id }) =>
            (budget ? id === budget : true) && (balance !== null || unlimitedMessaging)
        )
        .map(
          (
            { id, currencyCode = 'USD', balance, limitPerUser, name } = {},
            index,
            filteredCapBalanceByBudget
          ) =>
            id && (
              <Fragment key={id}>
                <Tooltip title={`Budget: ${name}`}>
                  <span>
                    {balance === null ? (
                      <>
                        {unlimitedMessaging} {currencies[currencyCode]?.symbol}
                      </>
                    ) : (
                      <>
                        {currencyFormat(balance, currencyCode)} (of{' '}
                        {currencyFormat(limitPerUser, currencyCode)})
                      </>
                    )}
                  </span>
                </Tooltip>
                {filteredCapBalanceByBudget.length === index + 1 ? null : ' + '}
              </Fragment>
            )
        )}
    </>
  );
};

export default CapBalance;
